import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import auth from './modules/auth';

export default new Vuex.Store({
	state: {
		sidebarCollapse: localStorage.getItem("sidebar-collapse") ?? false,
		spinner: false,
	},

	mutations: {
		showSpinner(state, val = false) {
			setTimeout(function () {
				state.spinner = val.show
			}, val?.sleep)
		}
	},

	actions: {
		setSpinner({ commit }, val) {
			commit('showSpinner', val)
		}
	},
	modules: {
		auth
	}
})
